import Vue from 'vue'
import { Table, Popconfirm, Button, Modal, Form, Input, Select, DatePicker, message, Popover } from 'ant-design-vue'
import '@/common/filters'

Vue.config.productionTip = false
Vue.use(Table)
Vue.use(Popconfirm)
Vue.use(Button)
Vue.use(Modal)
Vue.use(Form)
Vue.use(Input)
Vue.use(Select)
Vue.use(DatePicker)
Vue.use(Popover)
Vue.prototype.$message = message
Vue.prototype.$modal = Modal
Vue.prototype.$error = Modal.error
